import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPlacementMarginAddExtension,
  IPlacementMarginAddScenario,
  IPlacementMarginToolScenario,
  IPlacementMarginTreeViewBookingPeriod,
  IPlacementMarginDetailsResponse,
  IPlacementMarginDetailsResponseScenario,
  IPlacementMarginOverTimeHourlyRateItem,
  IPeopleSoftValues,
} from './add-edit-placement-scenario.model';
import { ITypeAheadOption } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PreferencesTab/CustomComponents/ControlledTypeAhead';
import {
  IAddScenarioForm,
  IAddScenarioRequestPayload,
  IScenarioSplit,
} from '@AMIEWEB/MarginTool/Components/PayPackage/AddScenario/model';
import { IGsaHousingDetailsSuymmaryResponse } from '@AMIEWEB/MarginTool/Components/PayPackage/models/PayPackage';
import { IMarginUpdateResponse } from '@AMIEWEB/MarginTool/Components/PayPackage/models/AddScenarioModal';
import {
  IDeletePlacementMarginToolDetailsPayload,
  IDeletePlacementMarginScenarioDetailsPayload,
} from '../placement-pay-package-status/placement-pay-package-status.model';
import { IMarginToolSave } from '@AMIEWEB/MarginTool/IMarginToolSave';

export const initialState: IPlacementMarginToolScenario = {
  addScenario: {
    placementId: 0,
    placementActivityTypeId: 0,
    placementStatusId: 0,
    placementStatus: '',
    isInExtension: false,
    extensionStatusId: 0,
    extensionStatus: '',
    startDate: '',
    endDate: '',
    duration: 0,
    tla: false,
    shiftId: 0,
    shiftDescription: '',
    placementStartDate: '',
    placementEndDate: '',
    placementDuration: 0,
    scenarioName: '',
    notes: '',
    payCycleEndDay: null,
    payCycleStartDay: null,
    payCycleStartDayNum: null,
    payCycleEndDayNum: null,
  },
  createdScenarioId: 0,
  shiftDetails: [],
  addExtension: {
    placementId: 0,
    placementActivityTypeId: 0,
    placementStatusId: 0,
    placementStatus: '',
    isInExtension: true,
    extensionName: '',
    extensionStatusId: 0,
    extensionStatus: null,
    startDate: '',
    endDate: '',
    duration: 0,
    shiftId: 0,
    shiftDescription: '',
    isExtensionFromPriorPlacementId: true,
    extensionOfPriorPlacementId: 0,
    tla: false,
    placementStartDate: null,
    placementEndDate: null,
    placementDuration: 0,
    hoursPerShift: 0,
    hoursPerWeek: 37.0,
    notes: '',
  },
  marginDetails: [],
  selectedEditScenario: null,
  gsaCalculatedValues: null,
  scenarioModal: { modalStatus: false, modalName: '' },
  deletedSplits: [],
  scenarioCreateUpdateResponse: null,
  selectedMarginDetail: null,
  scenariosTreeView: null,
  shouldFeatchScenarioCalculate: false,
  isPageLoaded: false,
  isSaveTriggered: false,
  isCancelTriggered: false,
  shouldShowOrderIdModifiedDialog: false,
  addEditScenarioModelData: null,
  isGroupUpdateInprogress: false,
  marginOverTimeHourlyRates: [],
  peopleSoftValues: [],
};

const getAddPlacementMarginScenarioDetails = createAction<{
  placementId: number;
  bookingPeriodId?: number | null;
  isExtensionFlow: boolean | false;
}>('GET_ADD_SCENARIO_DETAILS');
const getPlacementMarginToolDetails = createAction<{
  placementId: number;
  isDataUpdateFlow?: boolean | false | null;
  scenarioId?: number | null;
}>('GET_MARGIN_TOOL_DETAILS');
const setSelectedPlacementMarginScenarioData = createAction<IPlacementMarginDetailsResponseScenario>(
  'SET_SELECTED_PLACEMENT_MARGIN_SCENARIO',
);
const getPlacementMarginShiftDetails = createAction('GET_PLACEMENT_MARGIN_SHIFT_DETAILS');
const getNewPlacementMarginScenarioDefaultValues = createAction<{
  placementId: number;
  newScenario: IPlacementMarginDetailsResponseScenario;
}>('FETCH_PLACEMENT_MARGIN_SCENARIO_FORM_DATA');
const postAddPlacementMarginScenarioDetails = createAction<IAddScenarioRequestPayload>(
  'SAVE_ADD_PLACEMENT_MARGIN_SCENARIO_DETAILS',
);
const postEditPlacementMarginScenarioDetails = createAction<IAddScenarioRequestPayload>(
  'UPDATE_PLACEMENT_MARGIN_SCENARIO_DETAILS',
);
const postPlacementMarginToolDetails = createAction<IMarginToolSave>('SAVE_PLACEMENT_MARGIN_TOOL_DETAILS');
const postPlacementMarginToolDetailsValidate = createAction<IMarginToolSave>('VALIDATE_PLACEMENT_MARGIN_TOOL_DETAILS');

const getAddPlacementMarginExtensionDetails = createAction<{ placementId: number }>(
  'GET_ADD_PLACEMENT_MARGIN_EXTENTION_DETAILS',
);
const deleteSinglePlacementMarginScenario = createAction<IDeletePlacementMarginScenarioDetailsPayload>(
  'DELETE_SINGLE_PLACEMENT_MARGIN_SCENARIO',
);
const getPlacementMarginGSAcalculatedValues = createAction<{ autoSave?: boolean } | void>(
  'GET_PLACEMENT_MARGIN_GSA_CALCULATED_VALUES',
);
const getPlacementMarginGSACalculatedValuesSuccess = createAction('GET_PLACEMENT_MARGIN_GSA_CALCULATED_VALUES_SUCCESS');
const cleanPlacementMarginToolDetails = createAction<IDeletePlacementMarginToolDetailsPayload>(
  'CLEAN_PLACEMENT_MARGIN_TOOL_DETAILS',
);
const openPlacementMarginToolEditDetails = createAction('OPEN_EDIT_PLACEMENT_MARGIN_TOOL_DETAILS');

const placementMarginScenarioSlice = createSlice({
  name: 'placementMarginScenario',
  initialState,
  reducers: {
    setAddPlacementMarginScenarioData(state, action: PayloadAction<IPlacementMarginAddScenario>) {
      state.addScenario = action.payload;
    },
    setAddPlacementMarginExtentionData(state, action: PayloadAction<IPlacementMarginAddExtension>) {
      state.addExtension = action.payload;
    },
    setPlacementMarginBookingPeriod(state, action: PayloadAction<IPlacementMarginDetailsResponse>) {
      state.bookingPeriod = action.payload;
    },
    setPlacementMarginScenario(state, action: PayloadAction<IPlacementMarginDetailsResponseScenario>) {
      state.selectedScenario = action.payload;
    },
    setPlacementMarginShiftDetailsData(state, action: PayloadAction<ITypeAheadOption[]>) {
      state.shiftDetails = action.payload;
    },
    setPlacementMarginDetailResponse(state, action: PayloadAction<IPlacementMarginDetailsResponse[]>) {
      state.marginDetails = action.payload;
    },
    setCurrentEditPlacementMarginScenarioDetails(state, action: PayloadAction<IAddScenarioForm>) {
      state.selectedEditScenario = action.payload;
    },
    setPlacementMarginGSAcalculatedValues(state, action: PayloadAction<IGsaHousingDetailsSuymmaryResponse>) {
      state.gsaCalculatedValues = action.payload;
    },
    setPlacementMarginScenarioModal(
      state,
      action: PayloadAction<{ modalStatus: boolean | false; modalName: string | '' }>,
    ) {
      state.scenarioModal = action.payload;
    },
    setDeletedPlacementMarginScenarioSplits(state, action: PayloadAction<IScenarioSplit[]>) {
      state.deletedSplits = action.payload;
    },
    setPlacementMarginScenarioCreateUpdateResponse(state, action: PayloadAction<IMarginUpdateResponse | null>) {
      state.scenarioCreateUpdateResponse = action.payload;
    },
    setSelectedPlacementMarginDetail(state, action: PayloadAction<IPlacementMarginDetailsResponse>) {
      state.selectedMarginDetail = action.payload;
    },
    setPlacementMarginScenariosTreeView(state, action: PayloadAction<IPlacementMarginDetailsResponse[]>) {
      state.scenariosTreeView = action.payload;
    },
    setSelectedPlacementMarginSearchPlacement(
      state,
      action: PayloadAction<{
        placementId: number;
        removed: boolean;
        candidateFirstName?: string;
        candidateLastName?: string;
      }>,
    ) {
      state.selectedSearchPlacement = action.payload;
    },
    setFeatchPlacementMarginScenarioCalculate(state, action: PayloadAction<boolean | undefined | null>) {
      state.shouldFeatchScenarioCalculate = action.payload;
    },
    setPlacementMarginTreeViewBookingPeriod(
      state,
      action: PayloadAction<IPlacementMarginTreeViewBookingPeriod | undefined | null>,
    ) {
      state.selectedTreeViewBookingPeriod = action.payload;
    },
    setPlacementMarginPageLoadStatus(state, action: PayloadAction<boolean>) {
      state.isPageLoaded = action.payload;
    },
    setSavePlacementMarginTriggeredStatus(state, action: PayloadAction<boolean>) {
      state.isSaveTriggered = action.payload;
    },
    setCancelPlacementMarginTriggeredStatus(state, action: PayloadAction<boolean>) {
      state.isCancelTriggered = action.payload;
    },
    setPlacementMarginIsOrderIdModifiedStatus(state, action: PayloadAction<boolean>) {
      if (state.selectedScenario) {
        state.selectedScenario.isOrderIdModified = action.payload;
      }
    },
    setPlacementMarginShowOrderIdModifiedDialogStatus(state, action: PayloadAction<boolean>) {
      state.shouldShowOrderIdModifiedDialog = action.payload;
    },
    setAddEditPlacementMarginScenarioModelData(state, action: PayloadAction<IAddScenarioForm | null | undefined>) {
      state.addEditScenarioModelData = action.payload;
    },
    setPlacementMarginGroupUpdateInprogressStatus(state, action: PayloadAction<boolean>) {
      state.isGroupUpdateInprogress = action.payload;
    },
    setPlacementMarginOverTimeHourlyRates(state, action: PayloadAction<IPlacementMarginOverTimeHourlyRateItem[]>) {
      state.marginOverTimeHourlyRates = action.payload;
    },
    setPeopleSoftValues(state, action: PayloadAction<IPeopleSoftValues[]>) {
      state.peopleSoftValues = action.payload;
    },
    reset() {
      return {
        ...initialState,
      };
    },
  },
});

const { actions } = placementMarginScenarioSlice;

export const { name: placementMarginScenarioSliceKey, reducer: placementMarginScenarioReducer } =
  placementMarginScenarioSlice;

export const placementMarginScenarioActions = {
  ...actions,
  getAddPlacementMarginScenarioDetails: getAddPlacementMarginScenarioDetails,
  getPlacementMarginToolDetails: getPlacementMarginToolDetails,
  setSelectedPlacementMarginScenarioData: setSelectedPlacementMarginScenarioData,
  getPlacementMarginShiftDetails: getPlacementMarginShiftDetails,
  postAddPlacementMarginScenarioDetails: postAddPlacementMarginScenarioDetails,
  postEditPlacementMarginScenarioDetails: postEditPlacementMarginScenarioDetails,
  getNewScenarioDefaultValues: getNewPlacementMarginScenarioDefaultValues,
  getAddPlacementMarginExtensionDetails: getAddPlacementMarginExtensionDetails,
  deleteSinglePlacementMarginScenario: deleteSinglePlacementMarginScenario,
  getPlacementMarginGSAcalculatedValues: getPlacementMarginGSAcalculatedValues,
  getPlacementMarginGSACalculatedValuesSuccess: getPlacementMarginGSACalculatedValuesSuccess,
  postPlacementMarginToolDetails: postPlacementMarginToolDetails,
  postPlacementMarginToolDetailsValidate: postPlacementMarginToolDetailsValidate,
  cleanPlacementMarginToolDetails: cleanPlacementMarginToolDetails,
  openPlacementMarginToolEditDetails: openPlacementMarginToolEditDetails,
};
